// extracted by mini-css-extract-plugin
export default {"main":"PrimaryButton_main__9yGKz","transparent":"PrimaryButton_transparent__6rhp7","icon":"PrimaryButton_icon__qUA72","disabled":"PrimaryButton_disabled__-o5Hp"};